let currentTotalPrice = cartTotalPrice; // this is from cart-template-v2

/**
 * @function updateProductQuantity
 * @description Update cart item quantity or add product to cart
 * @async
 * @format [item.key]: quantity
 * @param {Object} data - An object containing the product key and its new quantity to be updated in the cart.
 * @returns {Object} cart object - an object containing cart details
 * @throws {Error} - an error occurred  during the request
 */


async function updateProductQuantity(data) {
	try {
		const request = {
			updates: { ...data },
		};
		// not sure why window.Shopify.routes.root doesn't work...
		const response = await fetch(window.location.origin + "/cart/update.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(request),
		});
		const responseData = await response.json();
		return responseData;
	} catch (error) {
		console.error(error);
	}
}

/**
 * @function updateCartIconItemQuantity
 * @description Update cart/bag icon item quantity
 * @param {number} quantity
 */
function updateCartIconItemQuantity(quantity) {
	const cartIconQuantityElement = document.querySelectorAll("span.cart_count");
	cartIconQuantityElement.forEach((el) => {
		el.innerHTML = quantity;
	});
}

/**
 * @function removeCartItemElement
 * @description removes cart item element from both desktop and mobile view
 *
 * Updates the following properties if applicable:
 * - hasKlangValleyProduct
 * - noSaturdayDelivery
 * - noSundayDelivery
 * - hasMarketPlaceProduct
 *
 * if there are no cart items left in either desktop or mobile view, the page will reload
 *
 * @async
 * @param {string} key - the id to remove cart item element
 *
 */
async function removeCartItemElement(key) {
	// remove desktop item
	const desktopCartItemElement = document.querySelector(`tr[data-key="${key}"]`);
	desktopCartItemElement.remove();
	// remove mobile item
	const mobileCartItemElement = document.querySelector(`.cart-item-container[data-key='${key}']`);
	mobileCartItemElement.remove();

	// update has klang valley only item property
	const getAllKVItems = document.querySelectorAll(".kv_product");
	if (getAllKVItems.length === 0) {
		deliveryDetailData.hasKlangValleyProduct = false;
		deliveryDetailData.checkForKlangValleyItemsOnly();
	}

	// update has no saturdays product item property
	const getAllNoSaturdayProduct = document.querySelectorAll(".no-saturdays");
	if (getAllNoSaturdayProduct.length === 0) {
		deliveryDetailData.noSaturdayDelivery = false;
	}

	// update has no sundays product item property
	const getAllNoSundayProduct = document.querySelectorAll(".no-sundays");
	if (getAllNoSundayProduct.length === 0) {
		deliveryDetailData.noSundayDelivery = false;
	}

	// update has marketplace item property
	const getAllMarketplaceItem = document.querySelectorAll(".marketplace_item");
	if (getAllMarketplaceItem.length === 0) {
		deliveryDetailData.hasMarketPlaceProduct = false;
		$(".marketplace").removeClass("marketplace_true");
		$(".marketplace-remark").hide();
	}

	const getAllNoPeakItems = document.querySelectorAll(".no_peak");
	if (getAllNoPeakItems.length === 0) {
		deliveryDetailData.hasProductWithNoPeakTag = false;
		reloadDatePicker();
	}

	const getAllNoPeak2Items = document.querySelectorAll(".no_peak2");
	if (getAllNoPeak2Items.length === 0) {
		deliveryDetailData.hasProductWithNoPeak2Tag = false;
		reloadDatePicker();
	}

	const getAllProductWithBlockDate = document.querySelectorAll(".product_has_block_dates");
	if (getAllProductWithBlockDate.length === 0) {
		deliveryDetailData.hasProductWithBlockDates = false;
		reloadDatePicker();
	}

	if ($("#deliveryCity").val()) initDatePicker();

	const cartItemsMobile = document.querySelectorAll(".cart-item-container");
	const cartItemsDesktop = document.querySelectorAll("tbody tr");

	if (cartItemsDesktop.length === 0 || cartItemsMobile.length === 0) {
		location.reload();
	}
}

/**
 * @function updateCartTotalPrice
 *
 * @description This function updates the total price of the cart and the quantity of items in the cart,
 * based on user input of quantity for a cart item.
 *
 * function only trigges in either of the following condition:
 * - when item change quantity
 * - when addons are selected
 * - need to update both mobile and desktop total price display
 *
 * Helper Functions used:
 * - updateTotalPriceWithAddons(): Updates the UI with the new total price, taking into account any add-ons or discounts.
 * - updateCartIconItemQuantity(totalQuantity): Updates the quantity of items in the cart icon in the UI.
 * - removeCartItemElement(cartItemKey): Removes the cart item element from the UI.
 *
 * @async
 * @param {Object} input
 */
async function updateCartTotalPrice(input) {
	try {
		$(".cart-item-quantity-box button").attr("disabled", true);
		const cartItemKey = input.currentTarget.id;
		const newQuantity = input.currentTarget.valueAsNumber;
		const data = {
			[cartItemKey]: newQuantity,
		};
		let totalQuantity = 0;

		const response = await updateProductQuantity(data);
		currentTotalPrice = response.total_price;

		if (response.items.length > 0) {
			response.items.forEach((item) => {
				totalQuantity += item.quantity;
			});
		}
		console.log("Input", input);
		
		updateTotalPriceWithAddons();
		updateCartIconItemQuantity(totalQuantity);

		if (newQuantity === 0) {
			removeCartItemElement(cartItemKey);
			reloadDatePicker();
		}

		$(".cart-item-quantity-box button").attr("disabled", false);
	} catch (error) {
		console.log(error);
	}
}


/**
 * @function updateProgressbar
 *
 * @description This function updates the progress bar to indicate how close the user is to free shipping
 * based on the current total price of the cart. It takes the current total price as an input
 * and calculates the progress percentage towards the price cap for free shipping (currently
 * set at RM250). It then updates the width of the progress bar and the progress label text
 * for both desktop and mobile views based on the progress percentage. If the current total
 * price is equal to or greater than the price cap, it displays a congratulatory message
 * instead of the progress label to inform the user that they have unlocked free shipping.
 *
 * @param {number} totalPrice
 * @example https://www.w3schools.com/howto/howto_js_progressbar.asp
 *
 * What it does:
 * - Calculates the progress percentage towards free shipping based on the current total price.
 * - updates the progress bar width and progress label text for both desktop and mobile views.
 * - if the total price is equal to or greater than the price cap for free shipping displays a
 * congratulatory message instead of the progress label.
 */
function updateProgressbar(totalPrice) {
	const desktopProgress = document.querySelector(
		".desktop-progress-with-label #progress-percentage"
	);
	const desktopProgressLabel = document.querySelector(".desktop-progress-with-label p");
	const mobileProgress = document.querySelector(".mobile-progress-with-label #progress-percentage");
	const mobileProgressLabel = document.querySelector(".mobile-progress-with-label p");
	const priceCap = 250;
	let progressPercentage = 0;
	let priceDifference = 0;

	progressPercentage = (totalPrice / priceCap) * 100;
	priceDifference = Number(priceCap - totalPrice).toFixed(2);

	if (totalPrice >= priceCap) {
		desktopProgressLabel.innerHTML = `<p>Congrats! You've unlocked <strong>Free Shipping</strong>!</p>`;
		mobileProgressLabel.innerHTML = `<p>Congrats! You've unlocked <strong>Free Shipping</strong>!</p>`;
	} else {
		desktopProgressLabel.innerHTML = `<p>You are <strong>RM${priceDifference}</strong> away from <strong>FREE SHIPPING</strong>!</p>`;
		mobileProgressLabel.innerHTML = `<p>You are <strong>RM${priceDifference}</strong> away from <strong>FREE SHIPPING</strong>!</p>`;
	}

	if (progressPercentage > 100) progressPercentage = 100;

	desktopProgress.style.width = progressPercentage + "%";
	mobileProgress.style.width = progressPercentage + "%";
}

$(".cart-item-quantity-box input.quantity").on("change", updateCartTotalPrice);

$("button#delete-item-button").on("click", function (e) {
	e.preventDefault();
	$(`.cart-item-quantity-box input[data-key="${e.currentTarget.dataset.key}"]`)
		.val(0)
		.trigger("change");
});

/**
 * @function updateTotalPriceWithAddons
 *
 * @description This function updates the total price of the cart by including the
 * cost of selected addons.
 *
 * This function is called when the user selects or deselects ad addon from the cart.
 *
 */
function updateTotalPriceWithAddons() {
	let grandTotal = 0;
	let addonTotalPrice = 0;
	const totalPriceContainer = document.querySelector("p.cart-total-price span.money");
	const mobileTotalPriceContainer = document.querySelector(".mobile-sticky-checkout button .money");
	const allAddonsSelectedDesktop = document.querySelectorAll(
		".cart-desktop-add-ons .main-pro .sub-pro"
	);
	const allAddonsSelectedMobile = document.querySelectorAll(
		".cart-mobile-add-ons .main-pro .sub-pro"
	);

	if (window.innerWidth >= 1024) {
		allAddonsSelectedDesktop.forEach((addon) => {
			if (addon.classList.contains("selected")) {
				addonTotalPrice += Number(addon.dataset.price);
			}
		});

		// console.log(addonTotalPrice);
	} else {
		allAddonsSelectedMobile.forEach((addon) => {
			if (addon.classList.contains("selected")) {
				addonTotalPrice += Number(addon.dataset.price);
			}
		});

		// console.log(addonTotalPrice);
	}

	grandTotal = (addonTotalPrice + currentTotalPrice) / 100;

	// updateProgressbar(Number(grandTotal));

	const formatedPrice = new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "MYR",
		currencyDisplay: "narrowSymbol",
	}).format(grandTotal);

	totalPriceContainer.innerHTML = formatedPrice;
	mobileTotalPriceContainer.innerHTML = formatedPrice;
}

/**
 * @function formValidation
 *
 * @description This is an asynchronous function that validates form inputs for a checkout page.
 * It performs checks on the delivery area, date, timeslot, and cart items, and displays
 * error messages accordingly. If all inputs are valid, it updates the product quantity
 * and proceeds to checkout.
 *
 * Outputs:
 * - prevent checkout if there is invalid item
 * - prevent checkout if date & timeslot is not selected
 * - Updates product quantity and triggers checkout process(if all inputs are valid)
 *
 * @async
 * @throws
 * - Please select at least one non-addon product to proceed to checkout
 * - Kindly select a different delivery area or remove specific products to proceed
 * - Please complete the following (input fields) to proceed
 */
async function formValidation() {
	const hasKlangValleyOnlyItem = deliveryDetailData.hasKlangValleyProduct;
	const deliveryAreaInput = document.querySelector("#deliveryCity");
	const deliveryDateInput = document.querySelector("#order_date");
	const deliveryTimeslotInput = document.querySelector("#order_time");
	const inputList = ["delivery area", "delivery date", "delivery timeslot"];
	const inputValues = [
		deliveryAreaInput.value,
		deliveryDateInput.value,
		deliveryTimeslotInput.value,
	];
	let errorMsg = "";
	// const cartItemsMobile = document.querySelectorAll(".cart-item-container");
	const cartItemsDesktop = document.querySelectorAll("tbody tr");
	const cartAddonItems = document.querySelectorAll(".cart-item-container.is-addon");

	if (
		hasKlangValleyOnlyItem &&
		!deliveryDetailData.hasMarketPlaceProduct &&
		deliveryDetailData.deliveryArea === "other"
	) {
		errorMsg =
			"Ops, it seems you have item(s) that is unavailable outside of Klang Valley. Please make sure the selected items are available in the selected area to proceed.";
		alert(errorMsg);
		return;
	}

	if (cartItemsDesktop.length === cartAddonItems.length) {
		errorMsg = "Please select at least one non-addon product to proceed to checkout";
		alert(errorMsg);
		// $(".checkout_error").text(errorMsg);
		// $(".checkout_error").show();
		return;
	}

	if (hasKlangValleyOnlyItem && deliveryDetailData.deliveryArea === "other") {
		errorMsg = "Kindly select a different delivery area or remove specific products to proceed.";
		alert(errorMsg);
		// $(".checkout_error").text(errorMsg);
		// $(".checkout_error").show();
		return;
	}

	if (!deliveryAreaInput.value || !deliveryDateInput.value || !deliveryTimeslotInput.value) {
		const emptyValues = [];
		inputValues.forEach((value, index) => {
			if (!value) {
				emptyValues.push(inputList[index]);
			}
		});
		errorMsg = `Please complete the following (${emptyValues.toString()}) to proceed.`;
		alert(errorMsg);
		// $(".checkout_error").text(errorMsg);
		// $(".checkout_error").show();

		if (!deliveryAreaInput.value) {
			$("#deliveryCity").addClass("error");
		}
		if (!deliveryDateInput.value) {
			$(".date-picker-container").addClass("error");
		}
		if (!deliveryTimeslotInput.value) {
			$(".time-picker-container").addClass("error");
		}

		if (window.innerWidth >= 1024) {
			window.scrollTo(0, 0);
		} else {
			const form = document.querySelector("form#cart_form");
			$(window).scrollTop(form.offsetTop - 175);
		}
		return;
	}

	// add addons to cart
	const selectedAddonsDesktop = document.querySelectorAll(
		".cart-desktop-add-ons .main-pro .sub-pro.selected"
	);
	const selectedAddonsMobile = document.querySelectorAll(
		".cart-mobile-add-ons .main-pro .sub-pro.selected"
	);
	const selectedAddonData = {};
	let hasKlangValleyOnlyAddons = false;

	if (window.innerWidth >= 1024) {
		selectedAddonsDesktop.forEach((item) => {
			if (item.dataset.vendor === "tier1") hasKlangValleyOnlyAddons = true;
		});
	} else {
		selectedAddonsMobile.forEach((item) => {
			if (item.dataset.vendor === "tier1") hasKlangValleyOnlyAddons = true;
		});
	}

	if (
		hasKlangValleyOnlyAddons &&
		!deliveryDetailData.hasMarketPlaceProduct &&
		deliveryDetailData.deliveryArea === "other"
	) {
		document.querySelector(".cart-desktop-add-ons .main-pro").classList.add("border-error");
		document.querySelector(".cart-mobile-add-ons .main-pro").classList.add("border-error");
		alert(
			"Ops, it seems you have item(s) that is unavailable outside of Klang Valley. Please make sure the selected items are available in the selected area to proceed."
		);
		return;
	}
	document.querySelector(".cart-desktop-add-ons .main-pro").classList.remove("border-error");
	document.querySelector(".cart-mobile-add-ons .main-pro").classList.remove("border-error");

	if (window.innerWidth >= 1024) {
		for (const addon of selectedAddonsDesktop) {
			selectedAddonData[addon.dataset.vid] = 1;
		}
		await updateProductQuantity(selectedAddonData);
	} else {
		for (const addon of selectedAddonsMobile) {
			selectedAddonData[addon.dataset.vid] = 1;
		}
		await updateProductQuantity(selectedAddonData);
	}

    // add selected card product to cart
    const selectedCard = {};
    selectedCard[$(".selected__card .card_message").attr("data-vid")] = 1
    await addCardProduct(selectedCard);
  
	// remove error border
	$("#deliveryCity").removeClass("error");
	$(".date-picker-container").removeClass("error");
	$(".time-picker-container").removeClass("error");

	// hide error msg
	$(".checkout_error").hide();
	// click real checkout button
	$(".checkout_original").trigger("click");
}

// add selected card product to cart
async function addCardProduct(data) {
	try {
		const request = {
			updates: { ...data },
		};
		// not sure why window.Shopify.routes.root doesn't work...
		const response = await fetch(window.location.origin + "/cart/update.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(request),
		});
		const responseData = await response.json();
		return responseData;
	} catch (error) {
		console.error(error);
	}
}

async function formValidationForMarketplaceProduct() {
	const cartItemsDesktop = document.querySelectorAll("tbody tr");
	const cartAddonItems = document.querySelectorAll(".cart-item-container.is-addon");

	if (cartItemsDesktop.length === cartAddonItems.length) {
		errorMsg = "Please select at least one non-addon product to proceed to checkout";
		alert(errorMsg);
		// $(".checkout_error").text(errorMsg);
		// $(".checkout_error").show();
		return;
	}

	// add addons to cart
	const selectedAddonsDesktop = document.querySelectorAll(
		".cart-desktop-add-ons .main-pro .sub-pro.selected"
	);
	const selectedAddonsMobile = document.querySelectorAll(
		".cart-mobile-add-ons .main-pro .sub-pro.selected"
	);
	const selectedAddonData = {};
	if (window.innerWidth >= 1024) {
		for (const addon of selectedAddonsDesktop) {
			selectedAddonData[addon.dataset.vid] = 1;
		}
		await updateProductQuantity(selectedAddonData);
	} else {
		for (const addon of selectedAddonsMobile) {
			selectedAddonData[addon.dataset.vid] = 1;
		}
		await updateProductQuantity(selectedAddonData);
	}

	// click real checkout button
	$(".checkout_original").trigger("click");
}

$("#checkout_clone, .mobile-sticky-checkout button").on("click", async function () {
	if (deliveryDetailData.hasMarketPlaceProduct) {
		await formValidationForMarketplaceProduct();
	} else {
		await formValidation();
	}
});


 // updateProgressbar(Number(currentTotalPrice) / 100);
$(document).ready(function(){
  reloadDatePicker();
});


/* For Card Message */
$(document).ready(function(){
  $(".card-message-wrapper a").click(function(){
    $(".card-message-wrapper a").removeClass("active"); // Sabhi elements se class hatao
    $(this).addClass("active"); // Clicked element par class add karo
    reloadDatePicker();
  });

  $(".card_message_main").click(function(){
    $(this).next("ul").slideToggle();
    $(this).toggleClass("open_card");
  });

  $(".card_message_cover ul li").click(function(){
    $("span.selected__card").html($(this).html());
    $(".card_message_main").trigger("click");
    
    
  });
});